export default "assets/images/icons/facebook-7ee2ddc8.svg";